<button
  type="button"
  class="nav-btn"
  [disabled]="disabled()"
  aria-label="Vorheriger Zeitraum"
  (click)="previous.emit()"
>
  <soft-ds-icon name="fa-regular fa-chevron-left" size="xs" aria-hidden="true" />
</button>
<button
  type="button"
  class="nav-btn"
  [disabled]="disabled()"
  aria-label="Aktueller Zeitraum"
  (click)="today.emit()"
>
  <soft-ds-icon name="fa-regular fa-square" size="sm" aria-hidden="true" />
</button>
<button
  type="button"
  class="nav-btn"
  [disabled]="disabled()"
  aria-label="Nächster Zeitraum"
  (click)="next.emit()"
>
  <soft-ds-icon name="fa-regular fa-chevron-right" size="xs" aria-hidden="true" />
</button>
